import dynamic from "next/dynamic";
import React, { FC, PropsWithChildren } from "react";

const InternalNoSSR: FC<PropsWithChildren> = (props) => (
  <React.Fragment>{props.children}</React.Fragment>
);

export const NoSSR = dynamic(() => Promise.resolve(InternalNoSSR), {
  ssr: false,
});
